/* istanbul ignore file */
import { utils as coreUtils } from '@codegrade/api-core';
import { parsers } from '@codegrade/utils';
import { FileTreeWithKey } from './FileTreeWithKey';
import { Work } from './Work';
const TestSubmissionWithFilesParser = 
/* #__PURE__ */ parsers.object([
    ['submission', Work],
    ['files', FileTreeWithKey],
]);
export class TestSubmissionWithFiles extends /* #__PURE__ */ coreUtils.AssigningBase {
    static decode(input) {
        return TestSubmissionWithFilesParser.decode(input).map(res => new TestSubmissionWithFiles(res));
    }
    static unsafeDecode(input) {
        return TestSubmissionWithFiles.decode(input).unsafeCoerce();
    }
    static encode(data) {
        return TestSubmissionWithFilesParser.encode(data);
    }
    static schema() {
        return TestSubmissionWithFilesParser.schema();
    }
}
